import Http from './base-http'

class User extends Http {
  login (credentials) {
    return this.client.post('login', credentials)
  }
  logout () {
    return this.client.post('logout')
  }
  createWorkscheduleRequest (uid,data) {
    return this.client.post(`${uid}/workschedulerequest`,data)
  }
  updateWorkscheduleRequest (uid,data) {
    return this.client.put(`${uid}/workschedulerequestuser`,data)
  }
  createOpenShiftRequest (osId,userId) {
    return this.client.post(`${userId}/workschedulerequest/openshift/apply/${osId}`)
  }
  deleteOpenShiftRequest(osId,userId) {
    return this.destroy(`${userId}/workschedulerequest/openshift/cancel/${osId}`)
  }
  fetchPermissions(uid){
    return this.client.get(`${uid}/permissions`)
      .then(({ data })=>{
        const userPermissions = { roles : {}, permissions : {} }
        if (data.permissions) {
          data.permissions.map(function (permName) {
            userPermissions.permissions[permName] = true
          })
        }
        if (data.roles) {
          data.roles.map(function (roleName) {
            userPermissions.roles[roleName] = true
          })
        }
        return userPermissions
      })
  }
  emailVerification(vc){
    return this.client.get(`onboarding/emailverification/${vc}`)
  }
  verifyEmail(vc){
    return this.client.put(`onboarding/verifyEmail/${vc}`)
  }
  onboardingSignup(data){
    return this.create('onboarding/signup', data)
  }
  register(data){
    return this.create('register', data)
  }
  importUsers(data){
    return this.create('importusers', data)
  }
  resendemailverification(id){
    return this.create(`${id}/resendemailverification`)
  }
  sendResetPasswordLink(data) {
    return this.create('forgotpassword', data)
  }
  deleteUser(id){
    return this.destroy(id, { timeout : 300000 })
  }
  getUpcommingEmployeeSchedule({ userId, fromDate, toDate }) {
    return this.get(`${userId}/upcomming-schedules/from/${fromDate}/to/${toDate}`)
  }
  getAttendanceSummary(userId) {
    return this.get(`${userId}/attendance/summary`)
  }
  getNotifications(userId) {
    return this.get(`${userId}/notifications`)
  }
}

const user = new User({ modelUrlPrefix : 'user' })

export default user
